import { isTruthy } from './isTruthy';
function toNaiveKebabCase(input) {
    return input.toLowerCase().replace(/ /g, '-');
}
export function mapButtonName(_a) {
    var section = _a.section, product = _a.product, action = _a.action;
    return [section, product, action].filter(isTruthy).map(toNaiveKebabCase).join('_');
}
//# sourceMappingURL=mapButtonName.js.map